import type { components } from '@/types/api/v1'
import dayjs, { type Dayjs } from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import tz from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
dayjs.extend(advancedFormat)
dayjs.extend(utc)
dayjs.extend(tz)
type DriverInfo = components['schemas']['DriverInfoRow']

export const getDriverShift = (driver: DriverInfo, override?: 'am' | 'pm') => {
  const shiftKey = override ?? driver.shift_preference
  const shift = (shiftKey === 'am' ? driver.am_shift : driver.pm_shift) ?? driver.am_shift ?? driver.pm_shift
  return shift
}

export const getDriverShiftStart = (driver: DriverInfo) => {
  const shift = getDriverShift(driver)
  if (!shift) return
  return dayjs(shift.start_time).tz(shift.timezone_data?.depot as string | undefined)
}

export const getDriverShiftTimes = (shift: components['schemas']['ShiftInfo'], day?: string, length = 12) => {
  const startTime = dayjs(shift.start_time).tz(shift.timezone_data?.depot as string | undefined)
  const start = (day ? dayjs.tz(day, shift.timezone_data?.depot as string) : dayjs(shift.start_time))
    .tz(shift.timezone_data?.depot as string | undefined)
    .hour(startTime.hour())
    .minute(startTime.minute())
  const end = start.add(length, 'hours')
  return { start, end }
}

export const getDriverDefaultShiftTimes = (driver: DriverInfo, type?: 'am' | 'pm', day?: string) => {
  const shift = getDriverShift(driver, type)
  const { start, end } = getDriverShiftTimes(
    shift ?? {
      timezone_data: { depot: dayjs.tz.guess() },
      start_time: dayjs().toISOString(),
      type: 'depot',
    },
    day,
    driver.shift_length?.shift_length_hours
  )
  return [start, end] as [Dayjs, Dayjs]
}

export const colDefIdToDay = (colDefId?: string) => {
  return dayjs.tz(colDefId, dayjs.tz.guess())
}
